import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-content-wrapper',
  templateUrl: './dashboard-content-wrapper.component.html',
  styleUrls: ['./dashboard-content-wrapper.component.css'],
})
export class DashboardContentWrapperComponent implements OnInit {
  @Input('title') title: string;
  @Input('subTitle') subTitle: string;
  @Input('isAddNewBtnEnabled') isAddNewBtnEnabled?: boolean;
  @Input('addNewUrl') addNewUrl?: string;

  constructor() {}

  ngOnInit(): void {}
}
